export const filteredCardDescription = {
  props: {
    chosenCustomerType: {
      type: String,
      required: false,
    },
  },
  computed: {
    filteredCardDescription() {
      if (this.chosenCustomerType === 'received_and_bought') return `Informações dos clientes que receberam no canal e compraram qualquer produto.`
      if (this.chosenCustomerType === 'received_and_bought_with_offer_products')
        return `Informações dos clientes que receberam no canal e compraram produtos da oferta.`
      if (this.chosenCustomerType === 'received_and_bought_with_received_product')
        return `Informações dos clientes que receberam no canal e compraram o produto que receberam via variável na mensagem.`
      return ''
    },
  },
}
